import { render, staticRenderFns } from "./ReleaseRequestForm.vue?vue&type=template&id=53c9c19a"
import script from "./ReleaseRequestForm.vue?vue&type=script&lang=js"
export * from "./ReleaseRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports